(() => {
  const parsePositiveInt = (value, fallback) => {
    const n = parseInt(String(value), 10);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  };

  const readPackConfig = (input) => {
    if (!input) return { min: 1, step: 1, allowZero: false };
    const step = parsePositiveInt(input.getAttribute("data-pack-step") || input.step, 1);
    const min = parsePositiveInt(input.getAttribute("data-pack-min") || input.min, step);
    const allowZero = input.getAttribute("data-pack-allow-zero") === "true";
    return { min, step, allowZero };
  };

  const snapQuantity = (raw, { min, step, allowZero }) => {
    let n = parseInt(String(raw), 10);
    if (!Number.isFinite(n)) return min;
    if (allowZero && n <= 0) return 0;
    if (n < min) return min;
    const rem = n % step;
    if (rem === 0) return n;
    return n + (step - rem);
  };

  const isPackInput = (input) => {
    if (!input || !input.hasAttribute("data-pack-step")) return false;
    const step = parsePositiveInt(input.getAttribute("data-pack-step"), 1);
    const min = parsePositiveInt(input.getAttribute("data-pack-min"), 1);
    return min > 1 || step > 1;
  };

  const applySnap = (input) => {
    if (!isPackInput(input)) return;
    const config = readPackConfig(input);
    if (config.step <= 1 && config.min <= 1) return;
    const snapped = snapQuantity(input.value, config);
    if (String(snapped) !== String(input.value)) {
      input.value = String(snapped);
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  document.addEventListener(
    "blur",
    (event) => {
      const input = event.target;
      if (input && input.matches && input.matches("[data-pack-step]") && isPackInput(input)) {
        applySnap(input);
      }
    },
    true
  );

  document.addEventListener("change", (event) => {
    const input = event.target;
    if (input && input.matches && input.matches("[data-pack-step]") && isPackInput(input)) {
      applySnap(input);
    }
  });

  window.showroomQuantityPack = {
    readPackConfig,
    snapQuantity,
    applySnap,
    isPackInput,
    adjustByButton(input, direction) {
      if (!input || !isPackInput(input)) return;
      const config = readPackConfig(input);
      const delta = direction < 0 ? -config.step : config.step;
      let n = parseInt(input.value, 10);
      if (!Number.isFinite(n)) n = config.min;
      n += delta;
      if (config.allowZero && n <= 0) {
        input.value = "0";
        return;
      }
      n = Math.max(config.min, n);
      input.value = String(snapQuantity(n, config));
      input.dispatchEvent(new Event("input", { bubbles: true }));
    },
  };
})();
